"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CircularProgressBar", {
    enumerable: true,
    get: function() {
        return CircularProgressBar;
    }
});
var _react = /*#__PURE__*/ _interopRequireDefault(require("react"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var CircularProgressBar = function(param) {
    var className = param.className, size = param.size, radius = param.radius, percent = param.percent, strokeColor = param.strokeColor, strokeWidth = param.strokeWidth, trailColor = param.trailColor, children = param.children;
    var circumference = radius * 2 * Math.PI;
    var classes = {
        container: (0, _classnames.default)(_defineProperty({
            "inline-flex items-center justify-center overflow-hidden rounded-full relative": true
        }, className || "", className)),
        strokeCircle: (0, _classnames.default)(_defineProperty({
            "transform origin-center -rotate-90": true
        }, strokeColor, strokeColor))
    };
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: classes.container
    }, /*#__PURE__*/ _react.default.createElement("svg", {
        width: size,
        height: size
    }, /*#__PURE__*/ _react.default.createElement("circle", {
        className: trailColor,
        strokeWidth: strokeWidth,
        stroke: "currentColor",
        fill: "transparent",
        r: radius,
        cx: size / 2,
        cy: size / 2
    }), /*#__PURE__*/ _react.default.createElement("circle", {
        className: classes.strokeCircle,
        strokeWidth: strokeWidth,
        strokeDasharray: circumference,
        strokeDashoffset: circumference - percent / 100 * circumference,
        stroke: "currentColor",
        fill: "transparent",
        r: radius,
        cx: size / 2,
        cy: size / 2
    })), /*#__PURE__*/ _react.default.createElement("div", {
        className: "w-full h-full absolute left-0 top-0 flex items-center justify-center"
    }, children));
};

//# sourceMappingURL=CircularProgressBar.js.map